import { useRecoilValue, useSetRecoilState } from "recoil";
import { loginState } from "../../stores/loginState";
import { useMutation } from "react-query";
import { HandexInstance, HanjinInstance, KpcInstance, LogenInstance, LotteInstance } from "../instance";
import dayjs from "dayjs";
import { editDataState } from "../../stores/edit/editDataState";
import { isKpcCompany, normalizeKpcScanItem } from "../../utils/kpc";

// TODO 업무구분 수정 데이터 조회 API
const useGetEditData = ({ date, workType, carNum}) => {
  // NOTE 상태 변수 선언
  const login = useRecoilValue(loginState);
  const editData = useSetRecoilState(editDataState);

  const filterData = (data) => {
    // 필터링 로직 구현
    return data.filter(item => {
      const matchesWorkType = workType === "전체" || item.tm_dv === workType;
      const matchesBarcode = !carNum || String(item.car_num || "").includes(carNum);

      return matchesWorkType && matchesBarcode;
    });
  };

  const mutationOptions = {
    onSuccess: (data) => {
      if (data.result === "00" || data.result === "77") {
        const sourceData = isKpcCompany(login.company)
          ? (data.data?.items || []).map((item) => ({
              ...normalizeKpcScanItem(item),
              // KPC에는 차량번호가 없으므로 기존 그룹 화면에서는 스캐너명으로 표시한다.
              car_num: item.scanner_nm || "-",
            }))
          : data.data;
        const filteredData = filterData(sourceData);
        editData(filteredData);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  };

  const postData = {
    api: "invoiceAll",
    data: [
      {
        start_time: `${dayjs(date).format("YYYY-MM-DD")} 00:00:00`,
        end_time: `${dayjs(date).format("YYYY-MM-DD")} 23:59:59`,
        bran_cd: login.branchCode,
        longTime: "",
        car_num: "",
        company: login.company
      },
    ],
  };

  let mutationFn;

  if (login.company === "LOGEN") {
    mutationFn = () => LogenInstance.post("/lose", postData);
  } else if (login.company === "LOTTE") {
    mutationFn = () => LotteInstance.post("/lose", postData);
  } else if (login.company === "HANJIN") {
    mutationFn = () => HanjinInstance.post("/lose", postData);
  } else if (login.company === "HANDEX") {
    mutationFn = () => HandexInstance.post("/lose", postData);
  } else if (login.company === "KPC") {
    // 업무수정은 하루 전체 원장이 필요하므로 KPC 서버 페이지를 모두 모아 조회한다.
    mutationFn = async () => {
      const items = [];
      let page = 0;
      let totalCount = 0;

      do {
        const response = await KpcInstance.get("/customer/scans", {
          params: {
            startDate: dayjs(date).format("YYYY-MM-DD"),
            endDate: dayjs(date).format("YYYY-MM-DD"),
            page,
            size: 100,
          },
        });
        const pageData = response.data || {};
        items.push(...(pageData.items || []));
        totalCount = Number(pageData.totalCount) || 0;
        page += 1;
      } while (items.length < totalCount);

      return { result: "00", data: { items } };
    };
  } else {
    mutationFn = () => {
      throw new Error("Invalid company");
    };
  }

  return useMutation("getAmount", mutationFn, mutationOptions);
};

export default useGetEditData;
